<template>

  <div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-3" flat>

        <v-layout row wrap>

          <v-flex xs12 md12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title>{{$t('Bank-POS-Statement')}}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> {{ $t('Send-Mail') }}

</v-btn>

              <v-menu bottom="" left>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>



                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">

                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

<!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>Mail Gönder</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              label="Kime (e-posta)"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              label="Agency Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              label="Doc Type (sabit)"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              label="Agent Full Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              label="Mesaj"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>Gönder

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>



          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>

                  <v-card flat>

                    <v-layout row wrap>

                      <v-flex xs12 sm4 pt-2 md2>

                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"

                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"

                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>

                      </v-flex>

                      <v-flex xs12 pt-2 sm4 md2>

                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"

                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"

                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>

                      </v-flex>

                      <v-flex xs12 pt-2 sm4 md2>

                        <v-autocomplete :items="bankapositems" :rules="[v => !!v || $t('Mandatory-section')]"

                          item-text="Title" v-model="Rapor.BankaPosKodu" item-value="PosKodu" clearable

                          :label="$t('Pos-Code')"></v-autocomplete>

                      </v-flex>

                      <v-flex pt-2>

                        <v-layout>

                          <div v-if="load1">

                            <v-btn color="info" @click="getList()" fab small="" dark>

                              <v-icon>search</v-icon>

                            </v-btn>

                          </div>

                          <div v-if="progress">

                            <v-layout pt-3 align-center="">

                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                            </v-layout>

                          </div>

                          <v-badge color="white" :overlap="true">

                            <template v-slot:badge>

                              <v-icon v-if="filtrevarmi" large color="green">

                                check_circle_outline </v-icon>

                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"

                              @click="filtrele()" color="info" fab dark>

                              <v-icon>filter_list</v-icon>

                            </v-btn>

                            <v-tooltip bottom="" :activator="el" v-model="tooltip">

                              <span>{{$t('Add-Search-Filter')}}</span>

                            </v-tooltip>





                          </v-badge>

                        </v-layout>

                      </v-flex>

                    </v-layout>

                  </v-card>

                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>

                  <v-card flat class="white--text">

                    <v-card flat="">

                      <v-card-actions>

                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>

                            <v-toolbar flat="" size="120px" dark color="grey darken-5">

                              <v-toolbar-title> <span class="subheading white--text">

                                  {{Rapor.BankaPosKodu}}  {{$t('Bank-POS-Statement')}}

                                </span> </v-toolbar-title>

                              <v-spacer></v-spacer>

                              <v-flex xs6 sm6 md6>

                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"

                                   :label="this.$t('Search')" append-icon="search"></v-text-field>

                              </v-flex>

                            </v-toolbar>

                          </v-flex>

                          <v-flex xs12 sm12>

                            <v-card flat>

                              <div class="bankapos-report-table">
                              <ReportTable
                                :headers="headers"
                                :items="bankaPosTicketItems"
                                storage-key="bankaposraporu_ticket_columns"
                                :loading="progress"
                                :has-searched="itemsichat && itemsichat.length > 0"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Bank-POS-Statement')"
                                :export-meta-items="bankaPosExportMetaItems"
                                :export-summary-cards="bankaPosTicketSummaryCards"
                                :rows-per-page-items="[20, 50, 100, 250, 500, 1000]"
                              ></ReportTable>
                            </div>

                            </v-card>

                          </v-flex>

                          <v-flex ma-2 xs12 sm12 md12>

                            <v-layout align-center="" justify-center="" fill-height="">

                              <span class="subheading grey--text font-weight-bold">

                                 {{ $t('General-Totals') }}

                              </span>

                            </v-layout>

                          </v-flex>

                          <v-flex xs12 sm4 md6>

                            <v-card flat class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-start="" fill-height="">

                                    <span v-if="!itemsichat.length" class="subheading font-weight-bold">

                                      {{ $t('Total') }} :  0  {{$t('number-records-listed')}}

                                    </span>

                                    <span v-else class="subheading font-weight-bold">

                                      {{ $t('Total') }} :  {{itemsichat.length}}   {{$t('number-records-listed')}}.

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>

                          <v-flex xs12 sm4 md6>

                            <v-card flat class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="subheading font-weight-bold">

                                      {{ $t('Total-Pos-Amount') }} : {{dipToplam.ToplamBiletPosTutar | moneyformat }}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>

                        </v-layout>

                      </v-card-actions>

                    </v-card>

                  </v-card>

                </v-flex>

                <br />

                <v-flex xs12 v-if="Rapor.CariHareketGoster" sm12 md12 pb-3>

                  <v-card flat class="white--text">

                    <v-card flat="">

                      <v-card-actions>

                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>

                            <v-toolbar flat="" size="120px" dark color="grey darken-5">

                              <v-toolbar-title> <span class="subheading white--text">

                                  {{Rapor.BankaPosKodu}} {{$t('Bank-POS-Statement')}} ( {{ $t('Current-Actions') }} )

                                </span> </v-toolbar-title>

                              <v-spacer></v-spacer>

                              <v-flex xs6 sm6 md6>

                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchiadebilet"

                                   :label="this.$t('Search')" append-icon="search"></v-text-field>

                              </v-flex>

                            </v-toolbar>

                          </v-flex>

                          <v-flex xs12 sm12>

                            <v-card flat>

                              <div class="bankapos-report-table">
                              <ReportTable
                                :headers="headerscarihareket"
                                :items="bankaPosCariItems"
                                storage-key="bankaposraporu_cari_columns"
                                :loading="progress"
                                :has-searched="itemscari && itemscari.length > 0"
                                :show-search="true"
                                :search-label="$t('Search')"
                                :show-frontend-export="true"
                                :export-title="$t('Current-Actions')"
                                :export-meta-items="bankaPosExportMetaItems"
                                :export-summary-cards="bankaPosCariSummaryCards"
                                :rows-per-page-items="[20, 50, 100, 250, 500, 1000]"
                              ></ReportTable>
                            </div>

                            </v-card>

                          </v-flex>

                          <v-flex ma-2 xs12 sm12 md12>

                            <v-layout align-center="" justify-center="" fill-height="">

                              <span class="subheading grey--text font-weight-bold">

                                {{ $t('Current-Transaction-General-Totals') }}

                              </span>

                            </v-layout>

                          </v-flex>

                          <v-flex xs12 sm4 md6>

                            <v-card flat class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-start="" fill-height="">

                                    <span v-if="itemscari.length" class="subheading font-weight-bold">

                                      {{ $t('Total') }} : 0  {{$t('number-records-listed')}}.

                                    </span>

                                     <span v-else class="subheading font-weight-bold">

                                      {{ $t('Total') }} : {{itemscari.length}}  {{$t('number-records-listed')}}.

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>

                          <v-flex xs12 sm4 md3>

                            <v-card flat class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="subheading font-weight-bold">

                                       {{ $t('Total-Current-Debt') }}  : {{dipToplam.ToplamCariBorc | moneyformat }}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>

                          <v-flex xs12 sm4 md3>

                            <v-card flat class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-end="" fill-height="">

                                    <span class="subheading font-weight-bold">

                                       {{ $t('Total-Current-Due') }}  : {{dipToplam.ToplamCariAlacak | moneyformat }}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>







                        </v-layout>

                      </v-card-actions>

                    </v-card>

                  </v-card>

                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>

                  <v-card flat class="white--text">

                    <v-card flat="">

                      <v-card-actions>

                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>

                            <v-toolbar flat="" size="120px" dark color="grey darken-5">

                              <v-toolbar-title> <span class="subheading white--text">

                                  {{ $t('Grand-Total') }}

                                </span> </v-toolbar-title>

                              <v-spacer></v-spacer>

                            </v-toolbar>

                          </v-flex>



                          <v-flex xs12 sm4 md4>

                            <v-card flat class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Ticket-Amount')}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{dipToplam.ToplamBiletPosTutar | moneyformat }}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>

                          <v-flex xs12 sm4 md4>

                            <v-card flat class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-2 grey--text font-weight-bold">  {{ $t('Current-Price') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{dipToplam.ToplamCariPosTutar | moneyformat }}{{getparabirimi()}}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>

                          <v-flex xs12 sm4 md4>

                            <v-card flat class="grey--text">

                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>

                                  <v-divider light></v-divider>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="body-2 grey--text font-weight-bold">  {{ $t('Result') }}

                                    </span>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>

                                  <v-layout align-center="" justify-center="" fill-height="">

                                    <span class="subheading font-weight-">

                                      {{dipToplam.SonucPosTutar | moneyformat }}{{getparabirimi()}}</span>

                                  </v-layout>

                                </v-flex>

                              </v-layout>

                            </v-card>

                          </v-flex>

                        </v-layout>

                      </v-card-actions>

                    </v-card>

                  </v-card>

                </v-flex>

              </v-layout>

            </v-form>

          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"

            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">

            {{ text1 }}

            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">

            <v-card color="grey lighten-5">

              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

              <v-divider></v-divider>

              <v-card-text>

                <v-layout row="" wrap="">



                  <v-flex xs12 sm12 md12 pa-1>

                    <v-card flat class="white--text">

                      <v-card color="grey lighten-5" flat="">

                        <v-card-actions>

                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>

                                 <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="Rapor.CariKod" :loading="loading"

                                  v-model="Rapor.CariKod" ></cariaracomp>

                            </v-flex>



                            <v-flex xs12 sm12 md12>

                              <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-radio-group hide-details v-model="Rapor.PosTipi">

                                <v-radio value="0" :label="$t('All')"></v-radio>

                                <v-radio value="1" :label="$t('Only-Bank-Pos')"></v-radio>

                                <v-radio value="2" :label="$t('Only-Service-Pos')"></v-radio>

                              </v-radio-group>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="Rapor.CariHareketGoster" :label="$t('Show-Current-Transaction')" hide-details="">

                              </v-checkbox>

                            </v-flex>



                          </v-layout>

                        </v-card-actions>

                      </v-card>

                    </v-card>

                  </v-flex>





                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

              </v-card-actions>

            </v-card>

          </v-dialog>

        </v-layout>

      </v-card>

    </v-app>

  </div>

</template>



<script>

  import auth from '../../../api/auth'

  import tarihcomp from '../customcomp/tarihim'

  import helpers from "@/components/app/customcomp/helpers.js"

  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"

  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"

  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"

  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import ReportTable from "@/components/app/customcomp/ReportTable.vue"

  export default {

    data() {

      return {

        mailDialog: false,

mailValid: false,

mailLoading: false,

mailPayload: {

  To: "",

  AgencyName: "",

  DocType: "Banka Pos Ekstresi - Bank POS Statement",

  AgentFullName: "",

  CustomBody: ""

},

rules: {

  required: v => !!v || 'Zorunlu alan',

  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'

},

        PB:'TRY',

        sayfayetki: {

          Screen: false,

          Update: false,

          Save: false,

          Delete: false,

          Status: false,

          Message: null,

          islem: 0,

        },

        filtrevarmi: false,

        sonuc: 0,

        itemscari: [],

        dipToplam: {

          SonucPosTutar: 0,

          ToplamBiletPosTutar: 0,

          ToplamBiletTutar: 0,

          ToplamCariAlacak: 0,

          ToplamCariBorc: 0,

          ToplamCariPosTutar: 0

        },

        bankapositems: [],

        havayolubil: {

          havayolukodu: null,

          formno: null

        },

        referansitems: [],

        evraktipi: [],

        search: '',

        searchsatilanbilet: null,

        searchiadebilet: null,

        searchvoid: null,
        headers: [{
            text: this.$t('Sales-Date'),
            value: '_SatisTarihi',
            visible: true,
            sortable: true,
            type: 'date',
            align: 'left',
            width: '150px'
          },
          {
            text: this.$t('Airline-Code'),
            value: '_HavayoluKodu',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'center',
            width: '130px'
          },
          {
            text: this.$t('Ticket-No'),
            value: '_BiletNo',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '170px'
          },
          {
            text: this.$t('Sales-Type'),
            value: 'SatisTip',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'center',
            width: '140px'
          },
          {
            text: 'K.Tip',
            value: 'KKTip',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'center',
            width: '110px'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'FaturaNo',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '150px'
          },
          {
            text: this.$t('Customer'),
            value: 'CariKod',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '160px'
          },
          {
            text: this.$t('Name-of-Passenger'),
            value: 'YolcuAdi',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '220px'
          },
          {
            text: this.$t('Routes'),
            value: 'Parkurlar',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '220px'
          },
          {
            text: this.$t('Pos-Amount'),
            value: 'PosTutar',
            visible: true,
            sortable: true,
            type: 'money',
            align: 'right',
            width: '160px'
          },
          {
            text: this.$t('Slip-Code'),
            value: 'SlipKod',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'center',
            width: '140px'
          },
          {
            text: this.$t('Receipt-No'),
            value: 'MakbuzNo',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'center',
            width: '140px'
          }
        ],
        headerscarihareket: [{
            text: this.$t('Date'),
            value: 'Tarih',
            visible: true,
            sortable: true,
            type: 'date',
            align: 'left',
            width: '150px'
          },
          {
            text: this.$t('Document-Type-No'),
            value: '_EvrakTipNo',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '220px'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '300px'
          },
          {
            text: this.$t('Debit'),
            value: 'Borc',
            visible: true,
            sortable: true,
            type: 'money',
            align: 'right',
            width: '150px'
          },
          {
            text: this.$t('Credit'),
            value: 'Alacak',
            visible: true,
            sortable: true,
            type: 'money',
            align: 'right',
            width: '150px'
          },
          {
            text: this.$t('Credit-Card-No'),
            value: 'KrediKartNo',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '190px'
          }
        ],

        Rapor: {

          BankaPosKodu: null,

          CariKod: null,

          HavayoluKodu: null,

          PosTipi: '0', // 0 : Hepsi, 1 : Sadece Banka Pos, 2 : Sadece Servis Pos

          CariHareketGoster: false,

          SirketKodu: null,

          BaslangicTarih: null,

          BitisTarih: null,

        },

        valid: true,

        tumsirketler: '',

        loading: false,

        items: [],

        load: false,

        load1: true,

        search3: '',

        renk1: 'info',

        dialogfiltre: false,

        hesapkodu: [],

        kredikarti: [],

        statecari: [],

        searchcari: '',

        progress: false,

        tooltip: false,

        el: null,

        yok: false,

        itemsichat: [],

        itemsdishat: [],

        masrafmerkezikodu: 'Masraf',

        butondurum: true,

        snackbar: false,

        y: 'top',

        x: 'right',

        mode: '',

        timeout: 6000,

        text1: '',

        dictionary: {

          custom: {

            tarihsec: {

              required: () => this.$t('Please-select-a-date')

            },

            tarihsec1: {

              required: () => this.$t('Please-select-a-date')

            },

          }

        },

      }

    },

    beforeRouteEnter(to, from, next) {

      next(vm => {

        vm.prevRoute = from.path

      })

    },

    beforeMount: beforeMount,

    mounted() {

      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=credentials.ParaBirimi;

        var params3 = {

          CompanyCode: credentials.SirketKodu

        }

        this.$http.post(auth.API_URL + 'api/BankPos/List', params3, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.bankapositems = response.body

          this.progress = false

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable-bankpos'

            this.progress = false

            this.snackbar = true

          } else {

            this.text1 = 'Service Unavailable-bankpos'

            this.snackbar = true

            this.progress = false

          }

        })





      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              var url = '#' + this.prevRoute

              window.open(url, '_self')

            } else {

              var url = '#/'

              window.open(url, '_self')

            }

          } else {

          }

        });

      }

    },

    filters: {

      dateformat: function (t) {

        return helpers.dateformat(t);

      },

      moneyformat: function (m) {

        return helpers.moneyformat(m);

      },

      bakiyekontrol: function (m) {

        return helpers.bakiyekontrol(m);

      }

    },

    components: {

      'tarihcomp': tarihcomp,

      referansmerkezicomp,

      masrafmerkezicomp,

      havayollaricomp,

      yetkidialog,

      cariaracomp,
      ReportTable

    },


    computed: {
      bankaPosTicketItems() {
        var list = Array.isArray(this.itemsichat) ? this.itemsichat : []

        return list.map(function (item) {
          var row = Object.assign({}, item)
          row._SatisTarihi = item && item.BiletBilgi ? item.BiletBilgi.SatisTarihi : ''
          row._HavayoluKodu = item && item.BiletBilgi ? item.BiletBilgi.HavayoluKodu : ''
          row._BiletNo = item && item.BiletBilgi ? item.BiletBilgi.BiletNo : ''
          return row
        })
      },

      bankaPosCariItems() {
        var list = Array.isArray(this.itemscari) ? this.itemscari : []

        return list.map(function (item) {
          var row = Object.assign({}, item)
          row._EvrakTipNo = [
            item ? item.EvrakTipi : '',
            item ? item.EvrakNo : ''
          ].filter(function (x) {
            return x !== null && x !== undefined && x !== ''
          }).join(' - ')
          row.KrediKartNo = item && item.KrediKartNo !== undefined
            ? item.KrediKartNo
            : (item ? item['Kredi Kart No'] : '')
          return row
        })
      },

      bankaPosExportMetaItems() {
        return [
          { label: this.$t('Starting-Date'), value: this.Rapor ? this.Rapor.BaslangicTarih : '', type: 'date' },
          { label: this.$t('Finishing-Date'), value: this.Rapor ? this.Rapor.BitisTarih : '', type: 'date' },
          { label: this.$t('Pos-Code'), value: this.Rapor ? this.Rapor.BankaPosKodu : '' },
          { label: this.$t('Customer'), value: this.Rapor ? this.Rapor.CariKod : '' },
          { label: this.$t('Airline-Code'), value: this.Rapor ? this.Rapor.HavayoluKodu : '' },
          { label: this.$t('Show-Current-Transaction'), value: this.Rapor && this.Rapor.CariHareketGoster ? 'Evet' : 'Hayır' }
        ]
      },

      bankaPosTicketSummaryCards() {
        return [
          {
            title: this.$t('General-Totals'),
            items: [
              { label: this.$t('Total'), value: Array.isArray(this.itemsichat) ? this.itemsichat.length : 0 },
              { label: this.$t('Total-Pos-Amount'), value: this.dipToplam ? this.dipToplam.ToplamBiletPosTutar : 0, type: 'money' }
            ]
          },
          {
            title: this.$t('Grand-Total'),
            items: [
              { label: this.$t('Ticket-Amount'), value: this.dipToplam ? this.dipToplam.ToplamBiletPosTutar : 0, type: 'money' },
              { label: this.$t('Current-Price'), value: this.dipToplam ? this.dipToplam.ToplamCariPosTutar : 0, type: 'money' },
              { label: this.$t('Result'), value: this.dipToplam ? this.dipToplam.SonucPosTutar : 0, type: 'money' }
            ]
          }
        ]
      },

      bankaPosCariSummaryCards() {
        return [
          {
            title: this.$t('Current-Transaction-General-Totals'),
            items: [
              { label: this.$t('Total'), value: Array.isArray(this.itemscari) ? this.itemscari.length : 0 },
              { label: this.$t('Total-Current-Debt'), value: this.dipToplam ? this.dipToplam.ToplamCariBorc : 0, type: 'money' },
              { label: this.$t('Total-Current-Due'), value: this.dipToplam ? this.dipToplam.ToplamCariAlacak : 0, type: 'money' }
            ]
          },
          {
            title: this.$t('Grand-Total'),
            items: [
              { label: this.$t('Ticket-Amount'), value: this.dipToplam ? this.dipToplam.ToplamBiletPosTutar : 0, type: 'money' },
              { label: this.$t('Current-Price'), value: this.dipToplam ? this.dipToplam.ToplamCariPosTutar : 0, type: 'money' },
              { label: this.$t('Result'), value: this.dipToplam ? this.dipToplam.SonucPosTutar : 0, type: 'money' }
            ]
          }
        ]
      }
    },

    watch: {

    },

    methods: {

  getparabirimi() {

    return helpers.getparabirimi();

  },

  openMailDialog() {

    if (!this.mailPayload) this.mailPayload = {};

    this.mailPayload.DocType = "Banka Pos Ekstresi - Bank POS Statement";

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    this.mailDialog = true;

  },

  closeMailDialog() {

    this.mailDialog = false;

  },

  sendMail() {

    if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) return;

    if (!(this.$refs && this.$refs.formgunluksatis && this.$refs.formgunluksatis.validate && this.$refs.formgunluksatis.validate())) return;

    const credsRaw = window.localStorage.getItem('credentials');

    const creds = credsRaw ? JSON.parse(credsRaw) : {};

    const companyCode = this.tumsirketler === true ? '0' : (creds && creds.SirketKodu ? creds.SirketKodu : null);

    const R = JSON.parse(JSON.stringify(this.Rapor || {}));

    R.SirketKodu = companyCode;

    if (this.havayolubil && this.havayolubil.havayolukodu) {

      R.HavayoluKodu = this.havayolubil.havayolukodu;

    }

    const mp = this.mailPayload || {};

    const payload = {

      Input: R,

      Mail: {

        To: mp.To || "",

        AgencyName: mp.AgencyName || "",

        DocType: mp.DocType || "Banka Pos Ekstresi - Bank POS Statement",

        AgentFullName: mp.AgentFullName || "",

        CustomBody: mp.CustomBody || ""

      }

    };

    this.mailLoading = true;

    const endpoint = auth.API_URL + 'api/Report/MailGonderBankaPosExcel';

    this.$http.post(endpoint, payload, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } })

      .then(() => {

        this.mailLoading = false;

        this.mailDialog = false;

        this.text1 = this.$t ? this.$t('Email-sent') : 'Mail gönderildi.';

        this.snackbar = true;

      }, (err) => {

        this.mailLoading = false;

        const body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

        const msg = (body && (body.Message || body.message)) || err.statusText || (this.$t ? this.$t('Email-send-failed') : 'Mail gönderilemedi.');

        this.text1 = msg;

        this.snackbar = true;

      });

  },

      getList: getList,

      getListHtml: getListHtml,

      getListExcel: getListExcel,

      filtrele: filtrele,

      filtrekayit: filtrekayit,

      filtreiptal: filtreiptal

    }

  }



  function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {

      CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.itemsairlinelist = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'

        this.progress = false

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable'

        this.progress = false

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.hesapgurubu = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.doviztipi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable-Döviz'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable-Döviz'

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.masrafmerkezi = response.body

    }, (response) => {

      if (response.status === 0) {

      } else {

      }

    })

  }



  function filtrekayit() {

    this.filtrevarmi = true

    this.dialogfiltre = false

    this.getList()

  }

  function filtreiptal() {

    this.filtrevarmi = false

    this.dialogfiltre = false

    this.Rapor.CariKod = null

    this.Rapor.HavayoluKodu = null

    this.havayolubil.havayolukodu = null

    this.Rapor.PosTipi = '0'

    this.Rapor.CariHareketGoster = false

  }



  function getList() {

    if (this.$refs.formgunluksatis.validate()) {



      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false

        var listreferans = [];



        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        if (this.havayolubil.havayolukodu != null) {

          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu

        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Report/BankPosReport', params, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.itemsichat = response.body.BiletDetay

          this.dipToplam = response.body

          if (response.body.CariDetay != null) {

            this.itemscari = response.body.CariDetay

          }



          this.progress = false

          this.load1 = true

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }





  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {



      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false

        var listreferans = [];



        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var lang = localStorage.getItem('lang')

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        if (this.havayolubil.havayolukodu != null) {

          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu

        }

        var params = this.Rapor

        this.$http

          .post(auth.API_URL + "api/Report/BankPosReportHtml", params, {

            headers: {

              Authorization: "Bearer " + auth.getAuthHeader()

            }

          }).then((response) => {

            this.progress = false

            this.load1 = true

            if (lang=='en')

          {

            response.bodyText=response.bodyText.toString().replaceAll(" B"," D");

            response.bodyText=response.bodyText.toString().replaceAll(" A"," C");

             response.bodyText=response.bodyText.toString().replaceAll("Hava Yolu Code:","Airline Code");

             response.bodyText=response.bodyText.toString().replaceAll("Bilet No","Ticket No");

             response.bodyText=response.bodyText.toString().replaceAll("Fatura No","Invoice No");

             response.bodyText=response.bodyText.toString().replaceAll("Current Kodu","Current Code");

             response.bodyText=response.bodyText.toString().replaceAll("Yolcu Cdı","Passenger Name");

             response.bodyText=response.bodyText.toString().replaceAll("Parkur","Route");

             response.bodyText=response.bodyText.toString().replaceAll("Makbuz No","Receipt No");

             response.bodyText=response.bodyText.toString().replaceAll("Bilet Amountı","Ticket Amount");

             response.bodyText=response.bodyText.toString().replaceAll("Pos Tutarı","Pos Amount");

             response.bodyText=response.bodyText.toString().replaceAll("BİLET HAREKETLERİ","TICKET TRANSACTIONS");

             response.bodyText=response.bodyText.toString().replaceAll("TOPLAM TUTAR DİLGİLERİ","TOTAL AMOUNT INFORMATION");

             response.bodyText=response.bodyText.toString().replaceAll("BİLET TOPLAMI","TICKET TOTAL");

             response.bodyText=response.bodyText.toString().replaceAll("CARİ HAREKET TOPLAMI","TOTAL CURRENT MOVEMENT");

             response.bodyText=response.bodyText.toString().replaceAll("SONUÇ","RESULT");

             response.bodyText=response.bodyText.toString().replaceAll("TOPLAM :","TOTAL :");

             var bodyhtml=helpers.getTranslatedHtml(response.bodyText) ;

bodyhtml=bodyhtml.toString().replace('<title> BANKA POS EKSTRESİ </title>','<title> Bank POS Statement </title>');

bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>BANKA POS EKSTRESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>Bank POS Statement</font>")

             response.bodyText=bodyhtml;

          }

            var blob = new Blob([response.bodyText], {

              type: 'application/html'

            });

            var link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);

            link.download = "BankPos.html";

            link.click();

            this.itemsichat = response.body.BiletDetay

            this.dipToplam = response.body

            if (response.body.CariDetay != null) {

              this.itemscari = response.body.CariDetay

            }



          }, (response) => {

            if (response.status === 0) {

              this.text1 = 'Service Unavailable'

              this.snackbar = true

              this.progress = false

              this.load1 = true

            } else {

              this.text1 = 'Service Unavailable'

              this.snackbar = true

              this.progress = false

              this.load1 = true

            }

          })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }



  function getListExcel() {



    if (this.$refs.formgunluksatis.validate()) {



      var bastarih = new Date(this.Rapor.BaslangicTarih)

      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true

        this.load1 = false

        var listreferans = [];



        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        if (this.havayolubil.havayolukodu != null) {

          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu

        }

        var params = this.Rapor

        this.$http

          .post(auth.API_URL + "api/Report/BankPosReportExcel", params, {

            headers: {

              Authorization: "Bearer " + auth.getAuthHeader()

            },

            responseType: "arraybuffer"

          }).then((response) => {

            this.progress = false

            this.load1 = true

            var blob = new Blob([response.data], {

              type: 'application/xlsx'

            });

            var link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);

            link.download = "BankPos.xlsx";

            link.click();

            // this.itemsichat = response.body.BiletDetay

            // this.dipToplam = response.body

            // if (response.body.CariDetay != null) {

            //   this.itemscari = response.body.CariDetay

            // }



          }, (response) => {

            if (response.status === 0) {

              this.text1 = 'Service Unavailable'

              this.snackbar = true

              this.progress = false

              this.load1 = true

            } else {

              this.text1 = 'Service Unavailable'

              this.snackbar = true

              this.progress = false

              this.load1 = true

            }

          })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }



  function beforeMount() {





  }

</script>

<style scoped>

/* Bu stiller yalnızca bankaposraporu.vue sayfasına özeldir. */
.bankapos-report-table {
  width: 100%;
  margin-top: 4px;
}

.bankapos-report-table > * {
  width: 100%;
}

</style>
